const formUI = {};

formUI.selectUI = () => {
  const elems = document.querySelectorAll('.custom-select-ui');

  for (let i = 0; i < elems.length; i++) {
    const selTag = elems[i].querySelector('select');
    if (!selTag) return
    const opt = selTag.children;
    if (!opt) return
    const listSel = elems[i].querySelector('.sud-list');

    formUI.selectListText(opt, listSel)

    const btnSel = elems[i].querySelectorAll('.js-btn-sel');

    formUI.btnSelList(btnSel, elems[i]);

    const SelBtnTtl = elems[i].querySelector('.sud-title');

    SelBtnTtl.addEventListener('click', function (event) {
      elems[i].classList.toggle('is-open');
    });

    // select mobile
    selTag.addEventListener('change', function () {
      elems[i].querySelector('.sud-title').innerHTML = '';
      listSel.innerHTML = '';
      formUI.selectListText(opt, listSel);

      const btnSel = elems[i].querySelectorAll('.js-btn-sel');

      formUI.btnSelList(btnSel, elems[i]);
    });
  }
};

formUI.btnSelList = (param, elem) => {
  // ui click list

  for (let i = 0; i < param.length; i++) {
    param[i].addEventListener('click', function (event) {
      const selBtns = this.parentElement.parentElement.querySelectorAll('.js-btn-sel');

      formUI.btnSelListRemoveClass(selBtns);

      this.classList.add('is-active');

      if(elem.querySelector('select').id === 'js-select') {
        elem.querySelector('.sud-title').setAttribute('data-scrollinghbtn', this.dataset.scrollingbtn);
      }

      elem.querySelector('.sud-title').innerHTML = this.textContent;

      elem.classList.toggle('is-open');

      elem.querySelector('select').options[i].selected = true;

    });
  }
};

formUI.btnSelListRemoveClass = (param) => {
  for (let i = 0; i < param.length; i++) {
    param[i].classList.remove('is-active');
  }
}

formUI.selectListText = (param, selList) => {
  let classSelected = '';
  let text = '';
  let dataSetter;
  for (let i = 0; i < param.length; i++) {

    let dataSetterId = param[i].parentElement.id;
    if(dataSetterId == 'js-select') {
      if(typeof param[i].dataset.scrollingbtn != 'undefined') {
        dataSetter = param[i].dataset.scrollingbtn;
      } else {
        dataSetter = '';
      }
    }

    if ((param[i].selected === true) && !param[i].classList.contains('option-with-href')) {
      classSelected = 'is-active';

      param[i].parentElement.parentElement.querySelector('.sud-title').innerHTML = param[i].text;
    }

    text = param[i].text;

    if ((param[i].classList.contains('option-with-href')) && (param[i].classList.contains('is-active'))) {
      classSelected = 'is-active';

      param[i].parentElement.parentElement.querySelector('.sud-title').innerHTML = param[i].text;
      param[i].parentElement.parentElement.querySelector('.sud-title').setAttribute("data-scrollingbtn", param[i].dataset.scrollingbtn);
    }

    let elem = document.createElement('li');

    text = '<button class="js-btn-sel ' + classSelected + ' " data-scrollingbtn="' + dataSetter + '">' + text + '</button>';

    if (param[i].classList.contains('option-with-href')) {
      if (typeof param[i].dataset.redirectionUrl !== "undefined") {
        text = "<a href='" + param[i].dataset.redirectionUrl + "'>" + text + "</a>";
      }
    }

    elem.innerHTML = text;

    selList.appendChild(elem);

    classSelected = '';
  }

};

formUI.linkList = () => {
  const elems = document.querySelectorAll('.custom-link-ui');

  for (let i = 0; i < elems.length; i++) {
    const ttlBtn = elems[i].querySelector('.clu-title');
    ttlBtn.addEventListener('click', function (event) {
      elems[i].classList.toggle('is-open');
    });
  }
};

formUI.init = () => {
  formUI.selectUI();
  formUI.linkList();
};

document.addEventListener('DOMContentLoaded', function (event) {
  formUI.init();
});



// WEBPACK FOOTER //
// ./scripts/components/form-ui.js